/* jshint -W024 */
export default [
  {
    path: '*',
    meta: {
      public: true
    },
    redirect: {
      path: '/404'
    }
  },
  {
    path: '/',
    meta: {
      public: true
    },
    name: 'Root',
    redirect: {
      name: 'Landing'
    }
  },
  {
    path: '/landing',
    meta: {
      public: true,
      title: 'Pivot Fleet'
    },
    name: 'Landing',
    component: () => import(/* webpackChunkName: "routes" */ '../views/Landing')
  },
  {
    path: '/403',
    meta: {
      public: true,
      title: 'Acceso denegado'
    },
    name: 'AccessDenied',
    component: () => import(/* webpackChunkName: "routes" */ '../theme/views/Deny')
  },
  {
    path: '/404',
    meta: {
      public: true,
      title: 'Página no encontrada'
    },
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "routes" */ '../theme/views/NotFound')
  },
  {
    path: '/500',
    meta: {
      public: true,
      title: 'Error'
    },
    name: 'ServerError',
    component: () => import(/* webpackChunkName: "routes" */ '../theme/views/Error')
  },
  {
    path: '/login',
    meta: {
      public: true,
      title: 'Acceder'
    },
    name: 'Login',
    component: () => import(/* webpackChunkName: "routes" */ '../views/Login')
  },
  // Entorno Grupo (solo Administradores de Grupo)
  {
    path: '/grupo/admins',
    meta: {
      public: false,
      breadcrumb: false,
      groupAdmin: true,
      title: 'Administradores de Grupo'
    },
    name: 'GrupoAdmins',
    component: () => import(/* webpackChunkName: "grupo-panel" */ '../views/grupoPanel/GrupoAdmins')
  },
  {
    path: '/grupo/concesionarios',
    meta: {
      public: false,
      breadcrumb: false,
      groupAdmin: true,
      title: 'Concesionarios del grupo'
    },
    name: 'GrupoDealers',
    component: () => import(/* webpackChunkName: "grupo-panel" */ '../views/grupoPanel/GrupoDealers')
  },
  {
    path: '/grupo/concesionarios/:dealer_id',
    meta: {
      public: false,
      breadcrumb: false,
      groupAdmin: true,
      title: 'Detalles del concesionario'
    },
    name: 'GrupoDealerDetail',
    props: true,
    component: () => import(/* webpackChunkName: "grupo-panel" */ '../views/grupoPanel/GrupoDealerDetail')
  },
  {
    path: '/grupo/partners',
    meta: {
      public: false,
      breadcrumb: false,
      groupAdmin: true,
      title: 'Partners'
    },
    name: 'GrupoPartners',
    // Misma pantalla de Grupos de Partners que el Super Admin (el backend limita los datos al grupo)
    component: () => import(/* webpackChunkName: "partner" */ '../views/partner/Partner')
  },
  {
    path: '/grupo/colaboradores',
    meta: {
      public: false,
      breadcrumb: false,
      groupAdmin: true,
      title: 'Colaboradores'
    },
    name: 'GrupoColaboradores',
    component: () => import(/* webpackChunkName: "grupo-panel" */ '../views/grupoPanel/GrupoColaboradores')
  },
  {
    path: '/grupo/colaboradores/:colaborador_id',
    meta: {
      public: false,
      breadcrumb: false,
      groupAdmin: true,
      title: 'Detalles del colaborador'
    },
    name: 'GrupoColaboradorDetail',
    props: true,
    component: () => import(/* webpackChunkName: "grupo-panel" */ '../views/grupoPanel/GrupoColaboradorDetail')
  },
  {
    path: '/grupo/usuarios',
    meta: {
      public: false,
      breadcrumb: false,
      groupAdmin: true,
      title: 'Usuarios de los dealers'
    },
    name: 'GrupoUsers',
    component: () => import(/* webpackChunkName: "grupo-panel" */ '../views/grupoPanel/GrupoUsers')
  },
  {
    path: '/grupo/gruas',
    meta: {
      public: false,
      breadcrumb: false,
      groupAdmin: true,
      title: 'Grúas del grupo'
    },
    name: 'GrupoGruas',
    component: () => import(/* webpackChunkName: "grupo-panel" */ '../views/grupoPanel/GrupoGruas')
  },
  {
    path: '/grupo/ubicaciones',
    meta: {
      public: false,
      breadcrumb: false,
      groupAdmin: true,
      title: 'Ubicaciones del grupo'
    },
    name: 'GrupoUbicaciones',
    component: () => import(/* webpackChunkName: "grupo-panel" */ '../views/grupoPanel/GrupoUbicaciones')
  },
  {
    path: '/grupo/permisos',
    meta: {
      public: false,
      breadcrumb: false,
      groupAdmin: true,
      title: 'Permisos predefinidos'
    },
    name: 'GrupoPermisos',
    component: () => import(/* webpackChunkName: "grupo-panel" */ '../views/grupoPanel/GrupoPermisos')
  },
  {
    path: '/grupo/comodato',
    meta: {
      public: false,
      breadcrumb: false,
      groupAdmin: true,
      title: 'Plantillas de comodato'
    },
    name: 'GrupoComodato',
    component: () => import(/* webpackChunkName: "grupo-panel" */ '../views/grupoPanel/GrupoComodato')
  },
  {
    path: '/grupo/reports',
    meta: {
      public: false,
      breadcrumb: false,
      groupAdmin: true,
      title: 'Reports'
    },
    name: 'GrupoReports',
    component: () => import(/* webpackChunkName: "grupo-panel" */ '../views/grupoPanel/GrupoReports')
  },
  {
    path: '/grupo/configuracion',
    meta: {
      public: false,
      breadcrumb: false,
      groupAdmin: true,
      title: 'Configuración'
    },
    name: 'GrupoConfiguracion',
    component: () => import(/* webpackChunkName: "grupo-panel" */ '../views/grupoPanel/GrupoConfiguracion')
  },
  {
    path: '/dashboard',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Escritorio'
    },
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/Dashboard')
  },
  {
    path: '/user',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Usuarios'
    },
    name: 'User',
    component: () => import(/* webpackChunkName: "user" */ '../views/user/User')
  },
  {
    path: '/admin-user',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Administradores'
    },
    name: 'AdminUser',
    component: () => import(/* webpackChunkName: "user" */ '../views/user/AdminUser')
  },
  {
    path: '/chatbot-admin',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'ChatBot - Conversaciones'
    },
    name: 'ChatBotAdmin',
    component: () => import(/* webpackChunkName: "chatbot" */ '../views/chatbot/ChatBotAdmin')
  },
  {
    path: '/concesionario',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Concesionarios'
    },
    name: 'Concesionario',
    component: () => import(/* webpackChunkName: "concesionario" */ '../views/dealer/Dealer')
  },
  {
    path: '/concesionario/:dealer_id',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Detalles de los concesionarios',
      parentMenu: 'Activo'
    },
    name: 'DealerDetail',
    props: true,
    component: () => import(/* webpackChunkName: "concesionario" */ '../views/dealer/DealerDetail')
  },
  {
    path: '/partner',
    meta: {
      public: false,
      breadcrumb: false,
      adminOrGroupAdmin: true,
      title: 'Partners'
    },
    name: 'Partner',
    component: () => import(/* webpackChunkName: "partner" */ '../views/partner/Partner')
  },
  {
    path: '/grupos',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Grupos'
    },
    name: 'Grupo',
    component: () => import(/* webpackChunkName: "grupo" */ '../views/grupo/Grupo')
  },
  {
    path: '/partner-group/:groupId/users',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Usuarios del Grupo',
      adminOrGroupAdmin: true,
      allowGroupAdmin: true,
      parentMenu: 'Partner'
    },
    name: 'PartnerGroupUsers',
    component: () => import(/* webpackChunkName: "partner" */ '../views/partner/PartnerGroupUsers')
  },
  {
    path: '/equipamiento',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Equipamientos'
    },
    name: 'Equipamiento',
    component: () => import(/* webpackChunkName: "equipamiento" */ '../views/equipamiento/Equipamiento')
  },
  {
    path: '/colaborador',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Colaboradores'
    },
    name: 'Colaborador',
    component: () => import(/* webpackChunkName: "colaborador" */ '../views/colaborador/Colaborador')
  },
  {
    path: '/colaborador/:colaborador_id',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Detalles de los colaboradores',
      parentMenu: 'Activo'
    },
    name: 'ColaboradorDetail',
    props: true,
    component: () => import(/* webpackChunkName: "colaborador" */ '../views/colaborador/ColaboradorDetail')
  },
  {
    path: '/vehiculo',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Vehículos'
    },
    name: 'Vehiculo',
    component: () => import(/* webpackChunkName: "vehiculo" */ '../views/vehiculo/Vehiculo')
  },
  {
    path: '/completar-movimiento-primero',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Aviso de completar movimiento'
    },
    name: 'CompletarMovimientoPrimero',
    props: true,
    component: () => import(/* webpackChunkName: "vehiculo" */ '../views/CompletarMovimientoPrimero')
  },
  {
    path: '/vehiculo/:id',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Detalles de los vehículos',
      parentMenu: 'Activo'
    },
    name: 'VehiculoDetail',
    props: true,
    component: () => import(/* webpackChunkName: "vehiculo" */ '../views/vehiculo/VehiculoDetail')
  },
  {
    path: '/ubicacion',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Ubicación'
    },
    name: 'Ubicacion',
    component: () => import(/* webpackChunkName: "ubicacion" */ '../views/ubicacion/Ubicacion')
  },
  {
    path: '/ubicacion/:ubicacion_id',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Detalles de Ubicación',
      parentMenu: 'Activo'
    },
    name: 'UbicacionDetail',
    props: true,
    component: () => import(/* webpackChunkName: "ubicacion" */ '../views/ubicacion/UbicacionDetail')
  },
  {
    path: '/movimiento/:movimiento_id',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Detalles del movimiento',
      parentMenu: 'Activo',
      allowGroupAdmin: true
    },
    name: 'MovimientoDetail',
    props: true,
    component: () => import(/* webpackChunkName: "movimiento" */ '../views/movimiento/MovimientoDetail')
  },
  {
    path: '/movimiento',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Movimientos'
    },
    name: 'Movimiento',
    component: () => import(/* webpackChunkName: "movimiento" */ '../views/movimiento/Movimiento')
  },
  {
    path: '/planning',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Planning'
    },
    name: 'Planning',
    component: () => import(/* webpackChunkName: "planning" */ '../views/planner/Planner')
  },
  {
    path: '/pedido/:id',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Detalles de los pedidos',
      parentMenu: 'Activo'
    },
    name: 'PedidoDetail',
    props: true,
    component: () => import(/* webpackChunkName: "pedido" */ '../views/pedido/PedidoDetail')
  },
  {
    path: '/driver',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Drivers'
    },
    name: 'Driver',
    component: () => import(/* webpackChunkName: "driver" */ '../views/driver/Driver')
  },
  {
    path: '/driver/:driver_id',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Detalles del Conductor',
      parentMenu: 'Activo'
    },
    name: 'DriverDetail',
    props: true,
    component: () => import(/* webpackChunkName: "driver" */ '../views/driver/DriverDetail')
  },
  {
    path: '/grua',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Grúas'
    },
    name: 'Grua',
    component: () => import(/* webpackChunkName: "grua" */ '../views/grua/Grua')
  },
  {
    path: '/grua/:grua_id',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Detalles de Gruas',
      parentMenu: 'Activo'
    },
    name: 'GruaDetail',
    props: true,
    component: () => import(/* webpackChunkName: "grua" */ '../views/grua/GruaDetail')
  },
  {
    path: '/notificaciones',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Notificaciones'
    },
    name: 'Notificaciones',
    component: () => import(/* webpackChunkName: "notificaciones" */ '../views/notificaciones/Notificaciones')
  },
  {
    path: '/escaneo',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Escaneo'
    },
    name: 'Escaneo',
    component: () => import(/* webpackChunkName: "escaneo" */ '../components/PostLogin')
  },
  {
    path: '/settings',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Configuración'
    },
    name: 'Configuracion',
    component: () => import(/* webpackChunkName: "settings" */ '../views/settings/Settings')
  },
  {
    path: '/cesiones',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Cesión'
    },
    name: 'Cesión',
    component: () => import(/* webpackChunkName: "cesiones" */ '../views/cesion/Cesion.vue')
  },
  {
    path: '/cesiones/:cesion_id',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Detalles de la cesión',
      parentMenu: 'Activo',
      allowGroupAdmin: true
    },
    name: 'CesionDetail',
    props: true,
    component: () => import(/* webpackChunkName: "cesion" */ '../views/cesion/CesionDetail')
  },
  {
    path: '/comodatos',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Comodato'
    },
    name: 'Comodato',
    component: () => import(/* webpackChunkName: "commodato" */ '../views/commodato/Commodato.vue')
  },
  {
    path: '/commodatos',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Comodatos'
    },
    name: 'Commodato',
    component: () => import(/* webpackChunkName: "commodato" */ '../views/commodato/Commodato.vue')
  },
  {
    path: '/payment',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Pagos'
    },
    name: 'Payment',
    component: () => import(/* webpackChunkName: "payment" */ '../views/payment/Payment.vue')
  },
  {
    path: '/facturacion',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Facturación'
    },
    name: 'Facturacion',
    component: () => import(/* webpackChunkName: "facturacion" */ '../views/facturacion/Facturacion.vue')
  },
  {
    path: '/reset-password',
    meta: {
      public: true,
      breadcrumb: false,
      title: 'Resetear contraseña'
    },
    name: 'Password',
    component: () => import(/* webpackChunkName: "password" */ '../views/user/Password.vue')
  },
  {
    path: '/set-password',
    meta: {
      public: true,
      breadcrumb: false,
      title: 'Crear contraseña'
    },
    name: 'Password',
    component: () => import(/* webpackChunkName: "password" */ '../views/user/Password.vue')
  },
  {
    path: '/subscription-expired',
    meta: {
      public: true,
      breadcrumb: false,
      title: 'Suscripción expirada'
    },
    name: 'Suscripción expirada',
    component: () => import(/* webpackChunkName: "Suscripción expirada" */ '../components/SubscriptionExpired.vue')
  },
  {
    path: '/reportes',
    meta: {
      public: false
    },
    redirect: {
      name: 'Reporte1'
    }
  },
  {
    path: '/reportes/pendientes-antiguedad',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Movimientos pendientes y antigüedad',
      parentMenu: 'Reportes',
      allowGroupAdmin: true
    },
    name: 'Reporte1',
    component: () => import(/* webpackChunkName: "reportes" */ '../views/reportes/Reporte1.vue')
  },
  {
    path: '/reportes/uso-herramienta',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Uso real de la herramienta',
      parentMenu: 'Reportes',
      allowGroupAdmin: true
    },
    name: 'Reporte2',
    component: () => import(/* webpackChunkName: "reportes" */ '../views/reportes/Reporte2.vue')
  },
  {
    path: '/reportes/cesiones-comodatos',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Cesiones y comodatos',
      parentMenu: 'Reportes',
      allowGroupAdmin: true
    },
    name: 'Reporte3',
    component: () => import(/* webpackChunkName: "reportes" */ '../views/reportes/Reporte3.vue')
  },
  {
    path: '/reportes/stock-inmovilizado',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Stock inmovilizado',
      parentMenu: 'Reportes',
      allowGroupAdmin: true
    },
    name: 'Reporte4',
    component: () => import(/* webpackChunkName: "reportes" */ '../views/reportes/Reporte4.vue')
  },
  {
    path: '/reportes/danos-detectados',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Daños detectados',
      parentMenu: 'Reportes',
      allowGroupAdmin: true
    },
    name: 'Reporte5',
    component: () => import(/* webpackChunkName: "reportes" */ '../views/reportes/Reporte5.vue')
  },
  {
    path: '/reportes/pendientes-llegada',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Vehículos pendientes de llegada',
      parentMenu: 'Reportes',
      allowGroupAdmin: true
    },
    name: 'Reporte6',
    component: () => import(/* webpackChunkName: "reportes" */ '../views/reportes/Reporte6.vue')
  },
  {
    path: '/proceso/:proceso_id',
    meta: {
      public: false,
      breadcrumb: false,
      title: 'Detalles del proceso',
      parentMenu: 'Activo'
    },
    name: 'EstadoProcesoDetail',
    props: true,
    component: () => import(/* webpackChunkName: "proceso" */ '../views/proceso/EstadoProcesoDetail')
  }
]
